<template>
  <BaseChart :options="mergedOptions" />
</template>

<script>
import BaseChart from '@@/common/stats/BaseChart';
import { deepMerge } from '@/utils/object';

const baseAdOptions = {
  chart: {
    type: 'line',
    polar: false,
    panning: true,
    pinchType: 'x',
  },
  title: {
    text: null,
  },
  tooltip: {
    split: true,
    crosshairs: true,
    pointFormat:
      '<span style="display: inline-flex; color:{series.color}">{point.y}</span>',
    valueDecimals: 0,
  },
  plotOptions: {
    series: {
      showInNavigator: true,
      animation: false,
      dataLabels: {},
    },
  },
  legend: {
    layout: 'horizontal',
  },
};

export default {
  name: 'AdChart',
  components: {
    BaseChart,
  },
  props: {
    options: {
      required: true,
      type: Object,
    },
  },
  computed: {
    mergedOptions() {
      const result = deepMerge(baseAdOptions, this.options);
      return result;
    },
  },
};
</script>
